import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { SCALE, VALIDATION_STATES } from '../../utils/constants';
import { alto, apple, bondiBlue, boulder, catskillWhite, fairPink, mercury, mineShaft, thunderBird, white, willowBrook } from '@parchment/atoms';
import Skeleton from 'react-loading-skeleton';
const BORDER_RADIUS = {
  small: '4px',
  medium: '5px',
  large: '6px'
};
export const lineContentSeparatorURL = `data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg%0Axmlns:svg='http://www.w3.org/2000/svg'%0Axmlns='http://www.w3.org/2000/svg'%0Awidth='1.128172mm'%0Aheight='295.92447mm'%0AviewBox='0 0 1.128172 295.92447'%0Aversion='1.1'%0A%3E%3Cg transform='translate(-105.98448,-0.48880613)'%3E%3Cpath style='stroke:%23${alto.replace('#', '')};stroke-width:1;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;' d='m 106.61339,0.98806712 h -0.12965 V 295.91401 h 0.12965 z' /%3E%3C/g%3E%3C/svg%3E%0A`;

//Images are stored in the background as a dataURl in CSS.
export const validIconDataUrl = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64' fill='%23${apple.replace('#', '')}' aria-label='valid' role='img' color='%236DBE45' preserveAspectRatio='xMidYMid meet'%3E%3Cg%3E%3Cpath d='M59.704 15.94C62.566 20.842 64 26.195 64 31.997c0 5.808-1.434 11.161-4.296 16.064-2.862 4.903-6.745 8.779-11.642 11.641-4.903 2.862-10.257 4.295-16.065 4.295-5.803 0-11.156-1.434-16.059-4.295C11.034 56.84 7.152 52.963 4.29 48.06S0 37.805 0 31.997c0-5.802 1.428-11.155 4.29-16.057s6.745-8.785 11.648-11.647S26.195.004 31.997.004c5.809 0 11.162 1.428 16.065 4.289 4.898 2.861 8.78 6.744 11.642 11.647zM53.5 25.247c0-.778-.255-1.416-.753-1.914l-3.792-3.749c-.529-.529-1.154-.796-1.871-.796-.723 0-1.349.267-1.878.796L28.205 36.541l-9.412-9.417c-.529-.529-1.154-.79-1.878-.79-.723 0-1.349.261-1.878.79l-3.792 3.749c-.498.498-.747 1.142-.747 1.914 0 .753.249 1.379.747 1.877l15.087 15.079c.523.529 1.148.796 1.871.796.753 0 1.391-.267 1.92-.796l22.621-22.619c.501-.498.756-1.124.756-1.877z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E`;
export const warningIconDataUrl = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64' fill='%23${thunderBird.replace('#', '')}' aria-label='valid' role='img' color='%23CC1D22' preserveAspectRatio='xMidYMid meet'%3E%3Cg%3E%3Cpath d='M32 .004C14.327.004 0 14.329 0 32s14.327 31.996 32 31.996S64 49.671 64 32 49.673.004 32 .004zm-4.895 10.648h9.874a1.3 1.3 0 0 1 1.298 1.374l-1.188 21.019a1.3 1.3 0 0 1-1.298 1.227h-7.499c-.69 0-1.26-.538-1.298-1.227l-1.188-21.019a1.301 1.301 0 0 1 1.299-1.374zm4.916 42.696c-4.581 0-6.871-2.056-6.871-6.167 0-1.959.573-3.484 1.718-4.574s2.863-1.635 5.154-1.635c4.581 0 6.871 2.069 6.871 6.208-.001 4.112-2.291 6.168-6.872 6.168z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E`;
export const secureIconDataUrl = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='pi pi-secure-icon sc-bwzfXH hYrNli' viewBox='0 0 50.942 64' fill='%23${boulder.replace('#', '')}' role='img' preserveAspectRatio='xMidYMid meet' color='inherit'%3E%3Cg%3E%3Cpath d='M50.942 36.558v-6.227c0-3.319-2.85-6.007-6.362-6.007H6.361C2.849 24.325 0 27.012 0 30.332v27.654C0 61.308 2.849 64 6.361 64H44.58c3.512 0 6.362-2.692 6.362-6.015v-1.889h-8.334v-3.324h8.334v-4.576h-8.334v-3.323h8.334v-4.992h-8.334v-3.323h8.334zm-23.24 10.818v4.171c0 .969-.997 1.758-2.231 1.758-1.231 0-2.232-.789-2.232-1.758v-4.171a5.143 5.143 0 0 1-2.917-4.635 5.15 5.15 0 0 1 10.298 0c0 2.042-1.2 3.8-2.918 4.635zM12.205 15.844c0-5.533 4.49-10.024 10.027-10.024h6.476c5.536 0 10.032 4.491 10.032 10.024v7.021h7.102v-9.144C45.842 6.141 39.705 0 32.121 0H18.82C11.24 0 5.099 6.141 5.099 13.721v9.144h7.107v-7.021z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E`;
export const validationRequiredIconDataUrl = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='pi pi-validation-required-icon' viewBox='0 0 42.036 64' fill='%23${thunderBird.replace('#', '')}' role='img' preserveAspectRatio='xMidYMid meet' color='inherit'%3E%3Cg%3E%3Cpath d='M26.571 11.542L24.82 27.259l15.931-4.444 1.41 10.766-14.524 1.022 9.526 12.687-9.696 5.169-6.663-13.369-5.85 13.281-10.08-5.082 9.439-12.687-14.437-1.109 1.668-10.678 15.59 4.444-1.751-15.717h11.188z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E`;
export default function TextArea(_ref) {
  let {
    required = false,
    visited: visitedProp = false,
    onChange = () => undefined,
    onBlur = () => undefined,
    onFocus = () => undefined,
    scale = SCALE.medium,
    valid = VALIDATION_STATES.neutral,
    disabled = false,
    showRequiredInPlaceholder = false,
    loading = false,
    className,
    ...props
  } = _ref;
  const [visited, setVisited] = useState(visitedProp);
  const [value, setValue] = useState(props.value);
  const [focused, setFocused] = useState(false);
  useEffect(() => {
    setVisited(visitedProp);
  }, [visitedProp]);
  useEffect(() => {
    setValue(props.value);
  }, [props.value]);
  const handleChange = e => {
    setValue(e.target.value);
    onChange(e.target.value, e);
  };
  const handleBlur = e => {
    setVisited(true);
    setFocused(false);
    setValue((value === null || value === void 0 ? void 0 : value.trim()) || '');
    onBlur(e.target.value);
  };
  const handleFocus = e => {
    setFocused(true);
    onFocus(e.target.value);
  };
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        lineHeight: 0,
        marginTop: '-1px',
        height: '100%'
      }
    }, /*#__PURE__*/React.createElement(Skeleton, {
      height: '100%'
    }));
  }
  return /*#__PURE__*/React.createElement(Wrapper, {
    scale: scale,
    focused: focused,
    valid: valid,
    visited: visited,
    className: className,
    height: props.height || '100%'
  }, /*#__PURE__*/React.createElement(AreaOfText, {
    name: props.name,
    value: value || '',
    scale: scale || SCALE.medium,
    maxCharacterLimit: props.maxCharacterLimit,
    "data-visited": visited,
    "data-required": required,
    "data-valid": valid,
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    disabled: disabled,
    showRequiredInPlaceholder: showRequiredInPlaceholder,
    placeholder: props.placeholder || ''
  }), props.maxCharacterLimit && props.value !== undefined && props.value.length >= 0 && /*#__PURE__*/React.createElement(CounterBar, {
    scale: scale || SCALE.medium,
    maxCharacterLimit: props.maxCharacterLimit,
    characterCount: props.value.length
  }, props.value.length, " of ", props.maxCharacterLimit, " Characters Used"));
}
const Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "TextArea__Wrapper",
  componentId: "da7nlp-0"
})(["outline:none;border:none;width:100%;height:", ";display:flex;flex-direction:column;border-radius:", ";:focus{outline:none;}", " ", " ", " &.gc-top,&.gc-right,&.gc-bottom,&.gc-left,&.gc-none{border-width:0;margin-top:-1px;margin-left:-1px;}.gc-top &,.gc-right &,.gc-bottom &,.gc-left &,.gc-none &{border-radius:0;margin-top:-1px;margin-left:-1px;}.gc-top.gc-left &,&.gc-top.gc-left{border-top-left-radius:", ";}.gc-top.gc-right &,&.gc-top.gc-right{border-top-right-radius:", ";}.gc-bottom.gc-left &,&.gc-bottom.gc-left{border-bottom-left-radius:", ";}.gc-bottom.gc-right &,&.gc-bottom.gc-right{border-bottom-right-radius:", ";}"], props => props.height, props => ({
  small: '4px',
  medium: '5px',
  large: '6px'
})[props.scale], props => props.valid === VALIDATION_STATES.neutral && props.focused && `
        box-shadow: 0 0 5px 0px  ${bondiBlue};
    `, props => props.visited === true && props.valid === VALIDATION_STATES.success && props.focused && `
        box-shadow: 0 0 5px 0  ${apple};
    `, props => props.visited === true && props.valid === VALIDATION_STATES.error && props.focused && `
        box-shadow: 0 0 5px 0  ${thunderBird};
    `, props => BORDER_RADIUS[props.scale], props => BORDER_RADIUS[props.scale], props => BORDER_RADIUS[props.scale], props => BORDER_RADIUS[props.scale]);
const CounterBar = /*#__PURE__*/styled.div.withConfig({
  displayName: "TextArea__CounterBar",
  componentId: "da7nlp-1"
})(["height:", ";font-size:", ";line-height:", ";font-weight:700;padding-left:17px;box-shadow:inset 0 0 0 1px ", ";border-radius:", ";margin:0;", ""], props => ({
  small: '31px',
  medium: '41px',
  large: '41px'
})[props.scale], props => ({
  small: '13px',
  medium: '16px',
  large: '20px'
})[props.scale], props => ({
  small: '31px',
  medium: '41px',
  large: '41px'
})[props.scale], alto, props => ({
  small: '0 0 4px 4px',
  medium: '0 0 5px 5px',
  large: '0 0 6px 6px'
})[props.scale], props => props.characterCount <= props.maxCharacterLimit ? `background-color: ${mercury}; color: ${boulder};` : `background-color: ${fairPink}; color: ${thunderBird};`);
const AreaOfText = /*#__PURE__*/styled.textarea.withConfig({
  displayName: "TextArea__AreaOfText",
  componentId: "da7nlp-2"
})([":-webkit-autofill{transition:all 99999s,padding 100ms ease-out;}resize:none;box-sizing:border-box;background-color:", ";box-shadow:inset 0 0 0 1px ", ";border-radius:", ";font-size:", ";line-height:", ";width:100%;height:", ";border-style:none;font-weight:600;color:", ";transition:padding 100ms ease-out;padding:17px 17px;margin:", ";::placeholder{font-weight:normal;color:", ";}:-ms-input-placeholder{font-weight:normal;color:", ";}::-ms-input-placeholder{font-weight:normal;color:", ";}:focus{outline:none;}", " ", " ", " ", " ", ""], white, alto, props => props.maxCharacterLimit ? {
  small: '4px 4px 0 0',
  medium: '5px 5px 0 0',
  large: '6px 6px 0 0'
}[props.scale] : {
  small: '4px',
  medium: '5px',
  large: '6px'
}[props.scale], props => ({
  small: '13px',
  medium: '16px',
  large: '20px'
})[props.scale], props => ({
  small: '15px',
  medium: '18px',
  large: '23px'
})[props.scale], props => props.maxCharacterLimit ? `calc(100% - ${{
  small: '30px',
  medium: '40px',
  large: '40px'
}[props.scale]})` : '100%', mineShaft, props => props.maxCharacterLimit ? '0 0 -1px 0' : '0', boulder, boulder, boulder, props => props['data-valid'] === VALIDATION_STATES.neutral && `
        :focus {
            background-color: ${catskillWhite};
        }
    `, props => props['data-visited'] === true && props['data-valid'] === VALIDATION_STATES.success && `
        background-image: url("${validIconDataUrl}"), url("${lineContentSeparatorURL}");
        background-position: ${{
  small: '16px 50%',
  medium: '15px 50%',
  large: '13px 50%'
}[props.scale]},
            ${{
  small: '40px 50%',
  medium: '40px 50%',
  large: '40px 50%'
}[props.scale]};
        background-size: ${{
  small: '15px 15px',
  medium: '16px 16px',
  large: '20px 20px'
}[props.scale]},
            ${{
  small: '2px 85%',
  medium: '2px 85%',
  large: '2px 85%'
}[props.scale]};
        background-repeat: no-repeat, no-repeat;

        background-color: ${willowBrook};
        box-shadow: inset 50px 0 0 -43px ${apple}, inset 0 0 0 1px ${alto};
        padding-left: 55px;
    `, props => props['data-visited'] === true && props['data-valid'] === VALIDATION_STATES.error && `
        background-image: url("${warningIconDataUrl}"), url("${lineContentSeparatorURL}");
        background-position: ${{
  small: '16px 50%',
  medium: '15px 50%',
  large: '13px 50%'
}[props.scale]},
            ${{
  small: '40px 50%',
  medium: '40px 50%',
  large: '40px 50%'
}[props.scale]};
        background-size: ${{
  small: '15px 15px',
  medium: '16px 16px',
  large: '20px 20px'
}[props.scale]},
            ${{
  small: '2px 85%',
  medium: '2px 85%',
  large: '2px 85%'
}[props.scale]};
        background-repeat: no-repeat, no-repeat;


        background-color: ${fairPink};
        box-shadow: inset 50px 0 0 -43px ${thunderBird}, inset 0 0 0 1px ${alto};
        color: ${thunderBird};
        padding-left: 55px;
    `, props => props['data-visited'] !== true && props['data-required'] && props.showRequiredInPlaceholder && `
        background-image: url("${validationRequiredIconDataUrl}");
        background-position: ${{
  small: '16px 17px',
  medium: '15px 18px',
  large: '13px 18px'
}[props.scale]};
        background-size: ${{
  small: '15px 15px',
  medium: '16px 16px',
  large: '20px 20px'
}[props.scale]};
        background-repeat: no-repeat;

        padding-left: 45px;
    `, props => props.disabled && `
        color: ${boulder};
        background-image: url("${secureIconDataUrl}"), url("${lineContentSeparatorURL}");
        background-position: ${{
  small: '16px 50%',
  medium: '15px 50%',
  large: '13px 50%'
}[props.scale]},
            ${{
  small: '40px 50%',
  medium: '40px 50%',
  large: '40px 50%'
}[props.scale]};
        background-size: ${{
  small: '15px 15px',
  medium: '16px 16px',
  large: '20px 20px'
}[props.scale]},
            ${{
  small: '2px 85%',
  medium: '2px 85%',
  large: '2px 85%'
}[props.scale]};
        background-repeat: no-repeat, no-repeat;
        background-color: ${mercury};

        box-shadow: inset 50px 0 0 -43px ${alto}, inset 0 0 0 1px ${alto};
        padding-left: 55px;
    `);